var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcReminder = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "15px",
    viewBox: "0 0 13 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "AF02CEF4-0AC2-43C9-8879-D2462FDA1B3A")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "live-01",
    transform: "translate(-309.000000, -581.000000)",
    fill: "#12100B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(41.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button_CTA",
    transform: "translate(239.000000, 359.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(28.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button_icon",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6599872,9.90768167 L12.3591177,8.55018392 L12.3591177,5.20441312 C12.3949714,2.6360958 10.5995883,0.433671105 8.15217749,0.0436932012 C5.48302057,-0.320081383 3.03424553,1.62760898 2.68017154,4.3959808 C2.65628876,4.61216369 2.64433469,4.82958571 2.6443678,5.04718356 L2.6443678,8.55018392 L1.33753104,9.90768167 C1.00509657,10.2613026 0.908293767,10.786651 1.09156685,11.2425283 C1.27483993,11.6984057 1.70278328,11.9967433 2.17891909,12.0005681 L4.60760657,12.0005681 L4.60760657,12.2549829 C4.74038399,13.8087189 5.9950849,15 7.49875911,15 C9.00243333,15 10.2571342,13.8087189 10.3899117,12.2549829 L10.3899117,12.0005681 L12.8245664,12.0005681 C13.3004449,11.9960337 13.7276505,11.6969337 13.9097184,11.2408194 C14.0917863,10.7847051 13.9934714,10.2598718 13.6599872,9.90768167 L13.6599872,9.90768167 Z M8.94582721,12.2549829 C8.81560808,12.977656 8.20748132,13.5015029 7.49875911,13.5015029 C6.7900369,13.5015029 6.18191014,12.977656 6.05169102,12.2549829 L6.05169102,12.0005681 L8.94582721,12.0005681 L8.94582721,12.2549829 L8.94582721,12.2549829 Z M2.80548466,10.5000781 L3.65880729,9.61488804 C3.93325591,9.33368678 4.08794864,8.95034238 4.08845224,8.55018392 L4.08845224,5.04718356 C4.08973136,4.02392964 4.5159191,3.05085022 5.2580413,2.37675706 C5.99162956,1.68749744 6.97971319,1.36665265 7.96122417,1.49899517 C9.69026719,1.79126248 10.949121,3.35777389 10.9150333,5.17470045 L10.9150333,8.55018392 C10.9114456,8.94874421 11.0618824,9.33219335 11.3327436,9.61488804 L12.1920336,10.5000781 L2.80548466,10.5000781 Z",
    id: "ic_reminder"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcReminder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_reminder.5427d004.svg";
export { ForwardRef as ReactComponent };